export default function hasStateChanged(prev: any, next: any): boolean {
  if (!prev) return true;
  if (
    prev.direction !== next.direction ||
    prev.connected !== next.connected ||
    prev.faults !== next.faults ||
    prev.doorStatus?.frontOpen !== next.doorStatus?.frontOpen ||
    prev.doorStatus?.rearOpen !== next.doorStatus?.rearOpen ||
    prev.carCalls !== next.carCalls ||
    prev.hallCalls !== next.hallCalls ||
    prev.msg !== next.msg ||
    prev.bitmask !== next.bitmask ||
    prev.positionMap !== next.positionMap ||
    prev.serviceMap !== next.serviceMap
  ) {
    return true;
  }
  // Compare activeFaults
  const prevFaults = prev.activeFaults || [];
  const nextFaults = next.activeFaults || [];
  if (prevFaults.length !== nextFaults.length) return true;
  for (let i = 0; i < prevFaults.length; i += 1) {
    if (
      prevFaults[i].faultType !== nextFaults[i].faultType ||
      prevFaults[i].fault?.message !== nextFaults[i].fault?.message
    ) {
      return true;
    }
  }
  return false;
}
